import type { WindowDescriptor } from '@krp/client-runtime'

import type { OneCUiState } from '../../state'

/**
 * Окно «Создание по умолчанию» базы 1С (RP-SYN11): открывается из карточки
 * ресурса. `:rid` в адресе — настройки двух баз не смешиваются.
 */
export const ONEC_CREATE_DEFAULTS_WINDOWS = {
  createDefaults: 'onec.create-defaults',
} as const

export const createDefaultsWindows: readonly WindowDescriptor<OneCUiState>[] = [
  {
    kind: ONEC_CREATE_DEFAULTS_WINDOWS.createDefaults,
    scope: 'resource',
    paths: ['/onec/:rid/create-defaults'],
    label: 'Создание по умолчанию — 1С',
    size: 'md',
  },
]
